import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Emma Rose | Product Leader';
render(<App data-id="element-79" />, document.getElementById('root'));